import { Injectable } from '@angular/core';
import { BaseHttpService } from './basehttp.service';
import { NotificationService } from './notifications.service';
import { Constants } from '../../shared/constants';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

  constant: Constants = new Constants();
  private logBuffer: ExceptionModel[] = []; 
  private bufferTimer: any; 
  private bufferDelay: number = 30000; // Updated buffer delay to 30 seconds

  constructor(private baseHttpService: BaseHttpService, private notificationService: NotificationService) {
   
  }

  logError(message: string, stack: string) {
    const logEntry: ExceptionModel = {
      ErrorMessage: message,
      StackTrace: stack,
      Title: "Application Exception",
      Severity: "High"
    };

    console.log('Inside LoggingService');
    this.logBuffer.push(logEntry);

    // Start or reset the buffer timer
    if (!this.bufferTimer) {
      this.bufferTimer = setTimeout(() => this.flushLogs(), this.bufferDelay);
    }
  }

  private flushLogs() {
    if (this.logBuffer.length === 0) {
      return; // No logs to send
    }

    const logsToSend = [...this.logBuffer]; // Copy logs to send
    this.logBuffer = []; // Clear the buffer

    this.baseHttpService.post(this.constant.logException, logsToSend).subscribe(
      (result) => {
        if (result != null) {
          console.log('Logs sent successfully:', logsToSend);
        }
      },
      (error) => {
        console.error('Failed to send logs:', error);
      }
    );

    this.bufferTimer = null; 
  }
}

export class ExceptionModel {
  ErrorMessage: string;
  StackTrace: string;
  Title: string;
  Severity: string;
}